import React from 'react';

import type { IconProps } from '~/components/icons/types';

import SvgIcon from '../core/SvgIcon';

/** An outline shield, for guardrails: a rule that guards an action rather than locks it.
 *
 * ``iconColor`` is forwarded to ``SvgIcon`` rather than only applied to the path below. Left off,
 * the ``<svg>`` element takes SvgIcon's slate-900 default and the tint reaches the outline alone —
 * enough to render a nominally orange icon as a grey one. The path keeps its own ``stroke`` so the
 * outline is coloured whichever element a consumer's CSS ends up addressing, and ``fill="none"``
 * so it stays an outline against the fill SvgIcon sets.
 */
const ShieldIcon: React.FC<IconProps> = ({ iconColor, ...props }) => (
  <SvgIcon viewBox="0 0 24 24" iconColor={iconColor} {...props}>
    <path
      d="M20.25 5.25L12 2.25L3.75 5.25V11.0122C3.75 16.8951 8.73 18.8503 11.0625 21.4247C11.3082 21.6958 11.6455 21.75 12 21.75C12.3545 21.75 12.6918 21.6958 12.9375 21.4247C15.27 18.8503 20.25 16.8951 20.25 11.0122V5.25Z"
      stroke={iconColor}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default ShieldIcon;
